/* eslint-disable import-x/order */
import type { ReactNode } from 'react';
import { Fragment } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';

/**
 * This App import should be kept as the first import in order to avoid css
 * source ordering issues.
 */
import { App } from './App';
import { ClientRouteProvider } from './static-context';
import { ContentSplitProvider } from './abTesting/ContentSplitProvider';
import { useDefaultDiscountExperiment } from './hooks/useDefaultDiscountExperiment';

export function ClientApp() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <ClientRouteProvider>
            <ContentSplitProvider>
              <DefaultDiscountExperimentWrapper>
                <App />
              </DefaultDiscountExperimentWrapper>
            </ContentSplitProvider>
          </ClientRouteProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

/*
 * This is used to isolate the App from needing to know about split
 * It prevents the consumers of the App, i.e. Client and Server, to both require the split context
 */
function DefaultDiscountExperimentWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const discountChecked = useDefaultDiscountExperiment();
  // Use a key to force a re-render of children when the discountChecked value changes
  return <Fragment key={String(discountChecked)}>{children}</Fragment>;
}
